import { Component, Vue } from "vue-property-decorator";
import { EDUCATION_EVENT_TYPES } from "@/constants/EducationEventTypes";

@Component
export default class EducationEventMixin extends Vue {
  protected getStatusIcon(data: any): any | undefined {
    return EDUCATION_EVENT_TYPES.find((x) => x.type === data.item.educationEventType);
  }
}
